import Ajax from '../libraries/Ajax'

export const byLocation = (lat, lng) =>
    Ajax.get(`events/list_events/0/20/0?lat=${lat}&lng=${lng}`)
    
export const filter = (filter, limit = 20) =>
    Ajax.get(`events/list_events/0/${limit}/0?filter=${filter}`)

export const loadExtras = (token, allow_extra_sales = 0) =>
    Ajax.get(`events/extras/${token}/?allow_extra_sales=${allow_extra_sales}`)

export const checkoutExtras = (form) =>
    Ajax.post(`extra_sales/event`, form)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/utils/events.js